"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _fullscreenVideo = _interopRequireDefault(require("./fullscreenVideo.js"));

var _fullscreenImage = _interopRequireDefault(require("./fullscreenImage.js"));

var _fullscreenText = _interopRequireDefault(require("./fullscreenText.js"));

var _utils = require("../utils");

var _fullscreenBottomMobileBar = _interopRequireDefault(require("./fullscreenBottomMobileBar"));

var _consts = _interopRequireDefault(require("@wix/photography-client-lib/dist/src/utils/consts"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenSlider =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(FullscreenSlider, _React$Component);

  function FullscreenSlider(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.marginWidth = 0;
    return _this;
  }

  var _proto = FullscreenSlider.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!_utils.utils.isSmallScreen()) {
      this.initialArrowsFocus();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!_utils.utils.isSmallScreen()) {
      if (prevProps.current.idx !== this.props.current.idx) {
        if (this.props.current.idx <= 0) {
          this.rightArrowElement && this.rightArrowElement.focus();
        } else if (this.props.current.idx >= this.props.totalItems - 1) {
          this.leftArrowElement && this.leftArrowElement.focus();
        }
      } else if (prevProps.window.expanded !== this.props.window.expanded) {
        if (this.props.window.expanded) {
          this.initialArrowsFocus();
        } //else is handled in fullscreenDesktopNavbar componentDidUpdate

      }
    }
  };

  _proto.initialArrowsFocus = function initialArrowsFocus() {
    if (this.props.current.idx >= this.props.totalItems - 1) {
      this.leftArrowElement && this.leftArrowElement.focus();
    } else {
      this.rightArrowElement && this.rightArrowElement.focus();
    }
  };

  _proto.isInDisplayRange = function isInDisplayRange(idx) {
    if (this.props.styleParams.fullscreenLoop) {
      return true;
    } else {
      var range = _utils.utils.isTouch() ? 2 : 3;
      return Math.abs(this.props.current.idx - idx) <= range;
    }
  };

  _proto.getSlideWidth = function getSlideWidth(addMargins) {
    return this.props.window.size.width + (_utils.utils.isMobile() && addMargins ? 2 * this.marginWidth : 0); //add space for margins
  };

  _proto.prepareSlide = function prepareSlide(item) {
    var idx = item.idx;
    var inner;

    switch (item.type) {
      case 'video':
        inner = _react["default"].createElement(_fullscreenVideo["default"], {
          key: idx,
          item: item,
          isDisplayed: this.props.current.idx === idx,
          currentIdx: this.props.current.idx,
          isDummy: !this.isInDisplayRange(idx),
          window: this.props.window,
          styleParams: this.props.styleParams,
          actions: {
            onItemCreated: this.props.actions.onItemCreated
          }
        });
        break;

      case 'text':
        inner = _react["default"].createElement(_fullscreenText["default"], {
          key: idx,
          item: item,
          isZoom: this.props.isMobileZoom,
          isDummy: !this.isInDisplayRange(idx),
          window: this.props.window,
          actions: {
            onItemCreated: this.props.actions.onItemCreated
          }
        });
        break;

      case 'image':
      case 'picture':
      default:
        inner = _react["default"].createElement(_fullscreenImage["default"], {
          key: idx,
          item: item,
          isZoom: this.props.isMobileZoom,
          isDummy: !this.isInDisplayRange(idx),
          window: this.props.window,
          isMobile: _utils.utils.isMobile(),
          isInSEO: this.props.isInSEO,
          actions: {
            onItemCreated: this.props.actions.onItemCreated
          },
          expandInfoPosition: this.props.styleParams.expandInfoPosition
        });
    }

    return inner;
  };

  _proto.prepareInfo = function prepareInfo(itm) {
    if (!_utils.utils.isMobile()) {
      return null;
    } else if (this.props.customMobileSidebarRenderer) {
      var props = _objectSpread({}, this.props, {
        itm: itm
      });

      return this.props.customMobileSidebarRenderer(props);
    } else {
      return _react["default"].createElement(_fullscreenBottomMobileBar["default"], {
        current: this.props.current,
        item: itm,
        styleParams: this.props.styleParams,
        actions: this.props.actions
      });
    }
  };

  _proto.prepareSlides = function prepareSlides() {
    var slides = [];

    for (var i = 0; i < this.props.items.length; i++) {
      var isSwipeVersion = _utils.utils.isTouch();

      var animationType = isSwipeVersion ? 'swipe-' : 'fade-';
      var innerStyle = {
        width: this.getSlideWidth(false) + 'px'
      };
      var itm = this.props.items[i];
      var slidePos = i;
      var isCurrent = false;
      var slideClasses = ['pro-fullscreen-slide'];

      switch (slidePos - this.props.current.pos) {
        case 0:
          slideClasses.push(animationType + 'current current-slide fullscreen-current');
          isCurrent = true;
          break;

        case 1:
          slideClasses.push(animationType + 'adjacent next-slide');
          break;

        case -1:
          slideClasses.push(animationType + 'adjacent prev-slide');
          break;

        default:
          slideClasses.push(animationType + 'far-away');
      }

      if (this.props.animating) {
        slideClasses.push(animationType + 'animated');

        switch (slidePos - this.props.current.pos) {
          case 0:
            slideClasses.push(animationType + 'animated-current');
            break;

          case 1:
            if (this.props.direction === 1) {
              slideClasses.push(animationType + 'animated-next');
            }

            break;

          case -1:
            if (this.props.direction === -1) {
              slideClasses.push(animationType + 'animated-prev');
            }

            break;

          default:
            break;
        }
      }

      var opacity = isSwipeVersion || isCurrent ? 1 : 0;

      if (_utils.utils.browserIs('safari') && !_utils.utils.isMobile()) {
        Object.assign(innerStyle, {
          opacity: opacity,
          transform: 'none',
          WebkitTransform: 'none',
          MozTransform: 'none',
          msTransform: 'none',
          OTransform: 'none'
        });
      } else {
        Object.assign(innerStyle, {
          opacity: opacity,
          willChange: 'transform'
        });
      }

      slides.push(itm && itm.idx >= 0 ? _react["default"].createElement("div", {
        key: 'swipe-item-' + itm.idx,
        "data-index": itm.idx,
        className: slideClasses.join(' '),
        style: innerStyle,
        "data-hook": isCurrent ? 'fullscreen-current' : 'fullscreen-away',
        onDragStart: function onDragStart(e) {
          return e && e.preventDefault();
        }
      }, this.prepareSlide(itm), this.props.isMobileZoom ? null : this.prepareInfo(itm)) : _react["default"].createElement("div", {
        key: 'swipe-item-placeholder-' + slidePos,
        className: slideClasses.join(' '),
        style: innerStyle
      }));
    }

    return slides;
  };

  _proto.getLeftArrowSvg = function getLeftArrowSvg() {
    return _react["default"].createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      stroke: "none",
      width: "15",
      height: "27",
      viewBox: "0 0 15 27"
    }, _react["default"].createElement("g", {
      fillRule: "evenodd"
    }, _react["default"].createElement("path", {
      fillRule: "nonzero",
      d: "M14.258 1.53L13.198.47-.061 13.728l13.259 13.258 1.06-1.06L2.061 13.728z"
    })));
  };

  _proto.getRightArrowSvg = function getRightArrowSvg() {
    return _react["default"].createElement("svg", {
      fill: "currentColor",
      stroke: "none",
      width: "15",
      height: "27",
      viewBox: "0 0 15 27"
    }, _react["default"].createElement("g", {
      fillRule: "evenodd"
    }, _react["default"].createElement("path", {
      fillRule: "nonzero",
      d: "M.198 25.926l1.06 1.06 13.259-13.258L1.258.47.198 1.53l12.197 12.198z"
    })));
  };

  _proto.createNavArrows = function createNavArrows(leftArrowLeftPos, rightArrowLeftPos) {
    var _this2 = this;

    var loop = this.props.styleParams.fullscreenLoop;
    return [_react["default"].createElement("button", {
      className: 'pro-fullscreen-arrow has-custom-focus arrow-left fullscreen-icon' + (this.props.isExpandedView ? ' expanded' : '') + (this.props.current.idx <= 0 ? ' fullscreen-icon-disabled ' : ''),
      onClick: function onClick() {
        return _this2.props.actions.fadeToNextSlide(-1);
      },
      ref: function ref(_ref) {
        return _this2.leftArrowElement = _ref;
      },
      tabIndex: this.props.current.idx <= 0 ? -1 : 0,
      "aria-label": "Previous Item",
      style: {
        position: 'absolute',
        left: leftArrowLeftPos
      }
    }, this.getLeftArrowSvg()), _react["default"].createElement("button", {
      className: 'pro-fullscreen-arrow has-custom-focus arrow-right fullscreen-icon' + (this.props.isExpandedView ? ' expanded' : '') + (this.props.current.idx >= this.props.totalItems - 1 && !loop ? ' fullscreen-icon-disabled ' : ''),
      onClick: function onClick() {
        return _this2.props.actions.fadeToNextSlide(1);
      },
      ref: function ref(_ref2) {
        return _this2.rightArrowElement = _ref2;
      },
      tabIndex: this.props.current.idx >= this.props.totalItems - 1 ? -1 : 0,
      "aria-label": "Next Item",
      style: {
        position: 'absolute',
        left: rightArrowLeftPos
      }
    }, this.getRightArrowSvg())];
  };

  _proto.hasDescriptionOrLink = function hasDescriptionOrLink() {
    return this.props.current.item.description && this.props.styleParams.allowDescriptionExpand || typeof this.props.current.item.link.data !== 'undefined';
  };

  _proto.getBottomBarClass = function getBottomBarClass() {
    var className = '';

    if (this.props.styleParams.expandInfoPosition === _consts["default"].expandInfoPositions.BOTTOM && this.props.current.hasInfo) {
      className += ' pro-fullscreen-bottom-bar';

      if (this.hasDescriptionOrLink()) {
        className += ' has-description';
      }
    }

    return className;
  };

  _proto.render = function render() {
    var firstSlidePosition = this.props.current.pos * this.getSlideWidth(true) + this.marginWidth;
    var shouldShowStoreArrows = !_utils.utils.isSmallScreen();
    var leftArrowLeftPos = firstSlidePosition + (this.props.window.expanded ? 10 : 0);
    var rightArrowLeftPos = firstSlidePosition + (this.getSlideWidth(true) - (this.props.window.expanded ? 110 : 100));
    var swipeWrapStyle = {
      width: (this.props.current.pos * 2 + 1) * this.getSlideWidth(false),
      marginLeft: -1 * firstSlidePosition,
      willChange: 'transform'
    };

    if (this.props.isLandscape) {
      swipeWrapStyle.height = this.props.window.size.height;
    }

    return _react["default"].createElement("div", {
      id: "slider",
      className: "pro-fullscreen-swipe " + (_utils.utils.isMobile() ? this.props.isMobileZoom ? 'pro-fullscreen-zoom' : 'pro-fullscreen-scroll' : '') + " " + this.getBottomBarClass(),
      style: {
        marginLeft: this.marginWidth + 'px',
        marginRight: this.marginWidth + 'px'
      }
    }, _react["default"].createElement("div", {
      className: 'pro-fullscreen-swipe-wrap pro-fullscreen-before-swipe swipe-wrap-idx-' + this.props.current.idx,
      key: 'swipe-wrap',
      style: swipeWrapStyle
    }, shouldShowStoreArrows ? this.createNavArrows(leftArrowLeftPos, rightArrowLeftPos) : '', this.prepareSlides()));
  };

  return FullscreenSlider;
}(_react["default"].Component);

var _default = FullscreenSlider;
exports["default"] = _default;